module.exports = __webpack_public_path__ + "img/013.385f7521.jpg";